import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import {
  Card,
  CardText,
  CardHeader,
  CardBody,
  CardTitle,
  CardImg,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap"
import { Link } from "react-router-dom"
import "./ActFeed.css"
import { parseInt } from "lodash"
import ActivityFeedComment from "./ActivityFeedComment"

const ActivityFeedCard = props => {
  const [obj, setObj] = useState(JSON.parse(localStorage.getItem("authUser")))
  const [likedisable, setlikeDisable] = useState(false)
  const [likeCount, setlikeCount] = useState(props.cardLikeCount)
  const [unlikedisable, setunlikeDisable] = useState(false)
  const [commentsView, setCommentsView] = useState(false) // Fixed: changed from "" to false
  const [comment, setComment] = useState("")
  const [comments, setComments] = useState(props.cardComments || []) // Added state to manage comments
  
  // Added ref for video autoplay functionality
  const videoRef = useRef(null)

  // Added useEffect for video autoplay functionality
  useEffect(() => {
    const video = videoRef.current;
    if (!video || props.cardType === "image") return;

    // Handle video end event for replay
    const handleVideoEnd = () => {
      video.currentTime = 0; // Reset video to start
      video.play().catch((error) => {
        console.log('Replay failed:', error);
      });
    };

    // Add event listener for video end
    video.addEventListener('ended', handleVideoEnd);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Video is in view - play it
            video.play().catch((error) => {
              console.log('Autoplay failed:', error);
              // Autoplay might fail due to browser policies
            });
          } else {
            // Video is out of view - pause it
            video.pause();
          }
        });
      },
      {
        threshold: 0.5, // Trigger when 50% of video is visible
        rootMargin: '0px'
      }
    );

    observer.observe(video);

    // Cleanup
    return () => {
      if (video) {
        video.removeEventListener('ended', handleVideoEnd);
        observer.unobserve(video);
      }
    };
  }, [props.cardType]);

  function handleUserCommentSubmit(cardUrl) {
    // e.preventDefault();
    if (comment.trim()) {
      console.log("cmnt", comment)
      UploadComment2()
      setComment("")
      // callApi("addComment", cardUrl)
    } else {
      // if (!selectedFiles) {
      alert("Type comment first")
      // }
    }
  }
  // async function UploadComment() {
  // const resp=  await fetch(process.env.REACT_APP_ADMIN + "/userpost/addComment", {
  //     method: "POST", // *GET, POST, PUT, DELETE, etc.
  //     mode: "cors", // no-cors, *cors, same-origin
  //     cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
  //     credentials: "same-origin", // include, *same-origin, omit
  //     headers: {
  //       "Content-Type": "application/json",
  //       // 'Content-Type': 'application/x-www-form-urlencoded',
  //     },
  //     redirect: "follow", // manual, *follow, error
  //     referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  //     body: JSON.stringify(), // body data type must match "Content-Type" header
  //   }).then(data => {
  //     console.log("FFFFFFFFFFFFFFF", data)
  //   })
  // }

  const UploadComment2 = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_ADMIN + "/userpost/addComment", {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: JSON.stringify({
          Firstname: obj.Firstname,
          Email: obj.Email,
          Userposturl: props.cardUrl,
          UserComment: comment,
        }),
      });

      const data = await response.json();
      console.log("Comment saved:", data);

      // Update the comments in the UI
      const newComment = {
        Firstname: obj.Firstname,
        UserComment: comment,
        Email: obj.Email
      };
      setComments(prevComments => [...prevComments, newComment]);

    } catch (error) {
      console.error("Error saving comment:", error);
    }
  }

  const UploadComment = () => {
    async function postData(url = "", data = {}) {
      // Default options are marked with *
      const response = await fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data), // body data type must match "Content-Type" header
      })
      return response.json() // parses JSON response into native JavaScript objects
    }

    // postData(process.env.REACT_APP_ADMIN + "/userpost/addComment", {
    //   Firstname: obj.Firstname,
    //   Email: obj.Email,
    //   Userposturl: props.cardUrl,
    //   UserComment: comment,
    // }).then(data => {
    //   console.log(data); // JSON data parsed by `data.json()` call
    //   // setObj(data)
    //   // localStorage.setItem("authUser", JSON.stringify(data))
    // })
    var request = new XMLHttpRequest()
    request.open("POST", process.env.REACT_APP_ADMIN + "/userpost/addComment")
    request.setRequestHeader("Content-Type", "application/json")
    request.send(
      JSON.stringify({
        Firstname: obj.Firstname,
        Email: obj.Email,
        Userposturl: props.cardUrl,
        UserComment: comment,
      })
    )
  }

  const callApi = (type, Userposturl) => {
    // e.preventDefault()
    console.log("type", type, "Userposturl", Userposturl)
    async function postData(url = "", data = {}) {
      // Default options are marked with *
      const response = await fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data), // body data type must match "Content-Type" header
      })
      return response.json() // parses JSON response into native JavaScript objects
    }

    postData(process.env.REACT_APP_ADMIN + "/userpost/" + type, {
      Firstname: obj.Firstname,
      Email: obj.Email,
      Userposturl: props.cardUrl,
      UserComment: comment,
    }).then(data => {
      console.log(data) // JSON data parsed by `data.json()` call
      setObj(data)
      // localStorage.setItem("authUser", JSON.stringify(data))
    })

    //activity points start
    let activityArr = localStorage.getItem("activityArr")
    let activityPoints = 1
    if (!activityArr) {
      activityArr = []
    } else {
      activityArr = JSON.parse(activityArr)
    }
    let currentPageArr = activityArr.filter(elem => elem == "Like")

    if (!currentPageArr.length) {
      let obj = JSON.parse(localStorage.getItem("authUser"))
      async function ActivityApiCall(url = "", data = {}) {
        // Default options are marked with *
        const response = await fetch(url, {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "same-origin", // include, *same-origin, omit
          headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: "follow", // manual, *follow, error
          referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(data), // body data type must match "Content-Type" header
        })
        return response.json() // parses JSON response into native JavaScript objects
      }
      ActivityApiCall(process.env.REACT_APP_ADMIN + "/submitscore", {
        gname: "Like",
        id: obj.Email + "|" + obj.Firstname + "|" + obj.Teamname,
        score: activityPoints,
        typeActivity: "Like",
      }).then(data => {
        // console.log(data); // JSON data parsed by `data.json()` call
        // if(data[0]=="success"){}//for successfully adding points
        activityArr.push("Post")
        localStorage.setItem("activityArr", JSON.stringify(activityArr))
      })
    }
    // activity points end
  }

  const scrollToPost = id => {
    const targetDiv = document.getElementById(id)
    if (targetDiv) {
      targetDiv.scrollIntoView({
        behavior: "smooth",
        block: "end",
      })
    } else {
      console.error("targetDiv not found")
    }
  }

  useEffect(() => {
    setTimeout(() => {
      let url = window.location.search

      let temp1
      if (url) {
        temp1 = url.split("?post=")[1]
        scrollToPost(temp1)
      }
    }, 1000);

  }, [])

  // Update comments when props change
  useEffect(() => {
    setComments(props.cardComments || []);
  }, [props.cardComments]);

  return (
    <>
      {/* <Card className="p-1 border shadow-none"> */}
      {/* <div className="p-3">
                <h5>
                    <div to="blog-details" className="text-dark">
                        {props.cardUsername}
                    </div>
                </h5>
                <p className="text-muted mb-0">{props.cardCaption}</p>
            </div>

            <div className="position-relative">
            <center>
                {console.log(props.cardImage)}
                {(props.cardType=="image")
                    ?

                    <img
                        style={{ maxHeight: "50vh", height: "50vh" }}
                        src={props.cardUrl}
                        alt=""
                        className=""
                    />
                    :
                    <iframe
                        style={{ maxHeight: "50vh", height: "50vh",maxWidth:"45vw",width:"45vw" }}
                        title="Post Image/ Video"
                        className="embed-responsive-item"
                        src={props.cardUrl}
                    />
                }

                </center>
            </div> */}

      <Card
        className="activityCard"
        id={props.cardId}
        style={{ overflowY: "scroll", padding: "1rem 1rem 0rem 1rem" }}
      >
        <Row className="no-gutters">
          <Col md={6}>
            <CardBody>
              <h3 className="activity_username">
                {props.cardUsername}
              </h3>
              <p className="activity_caption" style={{ color: "ffffff" }}>
                {props.cardCaption}
              </p>

              <Col md={6} style={{ marginBlock: "15px 0" }}>
                {props.cardType == "image" ? (
                  <CardImg
                    className=""
                    src={props.cardUrl}
                    alt="User Post Image"
                    style={{ maxHeight: "400px" }}
                  />
                ) : (
                  <video
                    ref={videoRef}
                    controls
                    muted
                    playsInline
                    loop
                    title="Post Image/ Video"
                    className="embed-responsive-item activityVideo"
                    src={props.cardUrl}
                  >
                    <source src={props.cardUrl} type="video/mp4" />
                  </video>
                )}
              </Col>

              <CardText>
                <span
                  className="p-3"
                  // style={{position:"absolute",bottom:"0px"}}
                  id=" likeid"
                >
                  <ul className="list-inline" style={{ margin: "0px" }}>
                    <li className="list-inline-item me-3" style={{ width: "100%" }}>
                      <Link to="#" className="text-muted" style={{ display: "flex", justifyContent: "space-evenly" }}>
                        {/* <i className="bx bxs-heart align-middle text-muted me-1 increased-heartsize"></i>{" "} */}
                        {obj.Userlikedpost &&
                          obj.Userlikedpost.includes(props.cardUrl) ? (
                          <span style={{ color: "white" }}>
                            <button
                              type="button"
                              disabled={likedisable}
                              className="btntrans"
                              onClick={() => {
                                setlikeDisable(true)
                                setunlikeDisable(false)
                                setlikeCount(parseInt(likeCount) - 1)
                                callApi("disLikeUserPost", props.cardUrl)
                              }}
                            >
                              <i
                                className="bx bxs-heart align-middle  heartColor increased-heartsize"
                                style={{ color: "red" }}
                              ></i>
                            </button>
                            {likeCount}
                            {/* <div> You & {props.cardLikeCount} others</div> */}
                          </span>
                        ) : (
                          <span style={{ color: "white" }}>
                            <button
                              type="button"
                              disabled={unlikedisable}
                              className="btntrans"
                              onClick={() => {
                                setunlikeDisable(true)
                                setlikeDisable(false)
                                setlikeCount(parseInt(likeCount) + 1)
                                callApi("addUserPostLike", props.cardUrl)
                              }}
                            >
                              <i
                                className="bx bx-heart align-middle  heartColor increased-heartsize"
                                style={{ color: "red" }}
                              ></i>
                            </button>
                            {likeCount}
                            {/* <div> {props.cardLikeCount}</div> */}
                          </span>
                        )}
                        <button
                          style={{ color: "white" }}
                          type="button"
                          className="btntrans"
                          onClick={() => {
                            setCommentsView(!commentsView) // Toggle comments visibility
                          }}
                        >
                          <i
                            className="bx bx-comment-dots align-middle me-1 increased-heartsize"
                            style={{ color: "white" }}
                          ></i>
                          {comments.length} {/* Use local comments state */}
                        </button>
                        {/* post share */}

                        <button
                          type="button"
                          className="btntrans"
                          onClick={() => {
                            const cardUrl =
                              window.location.origin +
                              "/activityfeed?post=" +
                              props?.cardId
                            if (cardUrl) {
                              navigator.clipboard
                                .writeText(cardUrl)
                                .then(() => {
                                  alert("Link copied to clipboard")
                                  btoa(cardUrl)
                                })
                                .catch(err => {
                                  console.error("Failed to copy URL:", err)
                                })
                            }
                          }}
                        >
                          <i
                            className="bx bxs-share-alt align-middle me-1 increased-heartsize"
                            style={{ color: "white" }}
                          ></i>
                        </button>
                      </Link>
                    </li>
                    {/* <li className="list-inline-item me-3">
                        <Link to="#" className="text-muted">
                            <i className="bx bx-comment-dots align-middle text-muted me-1"></i>{" "}
                            12 Comments
                        </Link>
                    </li> */}
                  </ul>
                  {/* <p>
                    Neque porro quisquam est, qui dolorem ipsum quia
                    dolor sit amet
                </p>

                <div>
                    <Link to="#" className="text-primary">
                        Read more{" "}
                        <i className="mdi mdi-arrow-right"></i>
                    </Link>
                </div> */}
                </span>
              </CardText>
              {/* Comments section - Only show when commentsView is true */}
              {commentsView && (
                <div className="commentDiv" id="style-1" style={{
                  // maxHeight: "300px", 
                  overflowY: "auto",
                  marginBottom: "15px",
                  border: "1px solid #ccc",
                  padding: "10px",
                  borderRadius: "5px",
                  backgroundColor: "rgba(255,255,255,0.1)"
                }}>
                  {comments.length > 0 ? (
                    comments.map((comment, index) => {
                      return (
                        <ActivityFeedComment
                          key={index} // Added key prop for React list rendering
                          Firstname={comment.Firstname || comment.firstname || "Anonymous"}
                          UserComment={comment.UserComment || comment.userComment || "No comment"}
                        />
                      )
                    })
                  ) : (
                    <p style={{ color: "white", textAlign: "center" }}>No comments yet. Be the first to comment!</p>
                  )}
                </div>
              )}
              {/* Comment input form - Always show */}
              <Form>
                <FormGroup className="mb-4" row>
                  <Col lg="8">
                    <Input
                      id="ActCommentInput"
                      name=""
                      type="textarea"
                      className="form-control"
                      placeholder="Type Your comments here..."
                      onChange={e => {
                        setComment(e.target.value)
                      }}
                      value={comment}
                    />
                  </Col>
                  <Col lg="2">
                    <button
                      type="button"
                      style={{ backgroundColor: "#e84e16 !important", color: "white" }}
                      className="btn btn-feed mt-2"
                      onClick={() => {
                        handleUserCommentSubmit(props.cardUrl)
                      }}
                    >
                      Submit
                    </button>
                  </Col>
                </FormGroup>
              </Form>
            </CardBody>
          </Col>
        </Row>
      </Card>
    </>
  )
}

ActivityFeedCard.propTypes = {
  cardUsername: PropTypes.string,
  cardCaption: PropTypes.string,
  cardType: PropTypes.string,
  cardLikeCount: PropTypes.string,
  cardUrl: PropTypes.string,
  cardText: PropTypes.string,
  cardComments: PropTypes.array,
  cardId: PropTypes.string, // Added missing prop type
}

export default ActivityFeedCard